import { ADMIN_TABLES, LOGIN } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import { DEFAULT_SORT } from '../../constants/admin/tables';
import { get } from 'lodash';
import { CONTRACT_TYPES, VALUE_ALL } from '../../constants/settings';

const initialState = {
    0: {
        requestId: '',
        data: [],
        selected: [],
        fetching: false,
        fetched: false,
        disabled: false,
        sort: '',
        sortDirection: '',
        searchQuery: '',
        totalResults: 0,
        filters: { event: VALUE_ALL, status: VALUE_ALL, mailType: CONTRACT_TYPES.CLEARANCE }
    }
};

function tables(state = initialState, action) {
    switch (action.type) {
        case ADMIN_TABLES.INITIALIZE:
            return {
                ...state,
                [action.index]: {
                    ...initialState[0],
                    sortDirection: get(DEFAULT_SORT, `${action.model}.direction`) || '',
                    sort: get(DEFAULT_SORT, `${action.model}.field`) || ''
                }
            };
        case ADMIN_TABLES.UPDATE_FILTER:
            return {
                ...state,
                [action.index]: {
                    ...state[action.index],
                    filters: { ...(state[action.index].filters || {}), [action.name]: action.value }
                }
            };
        case ADMIN_TABLES.REFRESH:
            return { ...state, [action.index]: { ...state[action.index], fetched: false } };
        case ADMIN_TABLES.SORT:
            return {
                ...state,
                [action.index]: {
                    ...state[action.index],
                    sort: action.sort,
                    sortDirection: action.direction,
                    fetched: false
                }
            };
        case ADMIN_TABLES.SEARCH:
            return {
                ...state,
                [action.index]: {
                    ...state[action.index],
                    searchQuery: action.query,
                    fetched: false
                }
            };
        case ADMIN_TABLES.FETCH_START:
            return {
                ...state,
                [action.index]: { ...state[action.index], requestId: action.requestId, fetching: true }
            };
        case ADMIN_TABLES.FETCH_OK:
            if (state[action.index] && state[action.index].requestId === action.requestId) {
                return {
                    ...state,
                    [action.index]: {
                        ...state[action.index],
                        fetching: false,
                        fetched: true,
                        data: action.data,
                        sort: action.sort,
                        sortDirection: action.sortDirection,
                        totalPages: Math.ceil(action.totalResults / state[action.index].resultsPerPage) || 1,
                        totalResults: action.totalResults || 0
                    }
                };
            } else {
                return state;
            }
        case ADMIN_TABLES.SELECT:
            const index = state[action.index].selected.indexOf(action.id);
            return index === -1
                ? {
                      ...state,
                      [action.index]: { ...state[action.index], selected: [...state[action.index].selected, action.id] }
                  }
                : {
                      ...state,
                      [action.index]: {
                          ...state[action.index],
                          selected: [
                              ...state[action.index].selected.slice(0, index),
                              ...state[action.index].selected.slice(index + 1)
                          ]
                      }
                  };
        case ADMIN_TABLES.DISABLE:
            return { ...state, [action.index]: { ...state[action.index], disabled: true } };
        case ADMIN_TABLES.DELETE:
            return {
                ...state,
                [action.index]: {
                    ...state[action.index],
                    disabled: false,
                    data: state[action.index].data.filter(d => !action.removed.includes(d.id)),
                    selected: []
                }
            };
        case ADMIN_TABLES.CHANGE:
            return {
                ...state,
                [action.index]: {
                    ...state[action.index],
                    currentPage: action.currentPage,
                    resultsPerPage: action.resultsPerPage
                }
            };
        case ADMIN_TABLES.UPDATE:
            return {
                ...state,
                [action.index || 0]: {
                    ...state[action.index || 0],
                    [action.field]: action.value
                }
            };
        case LOGIN.CANCEL:
        case LOCATION_CHANGE:
            return initialState;
        default:
            return state;
    }
}

export default tables;



// WEBPACK FOOTER //
// ./src/reducers/admin/tables.js